import React from 'react';
import { images, roles } from '../data/clinic';
export function TrainingClinic() {
  return <section className="bg-surface" data-id="element-277" data-mp="1ma5dio3n0wf8">
      <div className="mx-auto grid max-w-7xl gap-12 px-5 py-20 lg:grid-cols-12 lg:gap-16 lg:px-8 lg:py-24" data-id="element-278" data-mp="1m93zqbv8lvtt">
        <div className="lg:col-span-5" data-id="element-279" data-mp="20xqdi957ufix">
          <img src={images.procedure} alt="Behandeling onder röntgendoorlichting in de behandelkamer van Excellent Care Clinics" className="aspect-[4/5] w-full rounded-3xl object-cover" data-id="element-280" data-mp="1vzoybzawv0cq" />
        </div>
        <div className="lg:col-span-7 lg:pt-4" data-id="element-281" data-mp="13ccazmwxeoid">
          <h2 className="font-display text-3xl font-semibold tracking-tight text-ink sm:text-4xl" data-id="element-282" data-mp="1haansnvlmcvr">Opleidingskliniek</h2>
          <p className="mt-5 max-w-2xl text-lg leading-relaxed text-muted" data-id="element-283" data-mp="1d8pbb3mz80m3">
            Onze pijnkliniek is een opleidingskliniek. Dat betekent dat wij naast patiëntenzorg ook zorgverleners opleiden.
            Tijdens uw afspraak kunt u daarom ook contact hebben met een zorgverlener in opleiding. Dit gebeurt altijd onder
            supervisie en verantwoordelijkheid van een pijnspecialist.
          </p>
          <dl className="mt-10 divide-y divide-line border-y border-line" data-id="element-284" data-mp="2ji7umiupmzay">
            {roles.map(role => <div key={role.title} className="grid gap-2 py-6 sm:grid-cols-[220px_1fr] sm:gap-8" data-id="element-285" data-mp="2nldw7d6vo2b3">
                <dt className="font-display text-lg font-medium leading-snug text-ink" data-id="element-286" data-mp="2sjfevx0e5zm1">{role.title}</dt>
                <dd className="text-[15px] leading-relaxed text-muted" data-id="element-287" data-mp="1vv9ghru2c3g7">{role.text}</dd>
              </div>)}
          </dl>
        </div>
      </div>
    </section>;
}